import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useDxtradeInstrumentFeed } from '@pages/Trade/Markets/Instruments/hooks/useDxtradeInstrumentFeed'

import { BaseModalType } from '@context/ModalsContext'

import { Body1, Body2 } from '@ui/Typography'
import { Input } from '@ui/components/Input'
import { Modal } from '@ui/components/Modal'
import { SearchIcon } from '@ui/icons/Search.icon'

import { useDebouncedValue } from '@utils/debounce'

import { Box } from '@shared/components/Box'

import styles from './ChangeInstrumentModal.module.scss'

interface ChangeInstrumentModalProps {
  onSelect?: (symbol: string) => void
  accountCode: string
}
export const ChangeInstrumentModal: BaseModalType<ChangeInstrumentModalProps> = (props) => {
  const { close, onSelect, accountCode } = props
  const { t } = useTranslation()

  const [searchValue, setSearchValue] = useState('')

  const sanitizedSearchValue = searchValue.replace(/\//g, '')
  const debouncedSearchValue = useDebouncedValue(sanitizedSearchValue.trim(), 400)

  const searchValueWithWildcard = useMemo(() => {
    if (!debouncedSearchValue) {
      return ''
    }

    return `*${debouncedSearchValue}*`
  }, [debouncedSearchValue])

  const { instruments } = useDxtradeInstrumentFeed(accountCode, {
    limit: 2000,
    symbols: searchValueWithWildcard || undefined,
    symbolDescription: debouncedSearchValue || undefined,
  })
  return (
    <Modal>
      <Modal.Header canClose>{t('Markets.SymbolSearch')}</Modal.Header>
      <Modal.Body>
        <Box fullWidth>
          <Box mb='x16' className={styles.accountInfoWrapper}>
            <div className={styles.searchField}>
              <Input
                fullWidth
                label={t('Instruments.Search instruments')}
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                variant='search'
                size='lg'
                leftIcon={SearchIcon}
                autoFocus
              />
            </div>
            <div className={styles.symbolList}>
              {instruments.map((instrument) => (
                <div
                  key={instrument.symbol}
                  className={styles.symbolRow}
                  onClick={() => {
                    onSelect?.(instrument.symbol!)
                    close()
                  }}
                >
                  <Body1 bold color={'text-purple-high-em'}>
                    {instrument.symbol}
                  </Body1>

                  <Body2>{instrument.description}</Body2>
                </div>
              ))}
            </div>
          </Box>
        </Box>
      </Modal.Body>
    </Modal>
  )
}
